module.exports = __webpack_public_path__ + "media/images/diy/led_uplight_picture-e8bd30322382ec8ce219309ea3cb7c70.png";